export default "__VITE_ASSET__61486ebc__"